import { combineReducers } from "redux";
import coreReducer from "./coreR/index";
import derFeverReducer from "./derivedFeverR/index";

export default combineReducers({
  // below keys will be the names of these in state:
  core: coreReducer,
  derFever: derFeverReducer,
});
